import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
const ENDPOINT = `${getFullUrl('app-api')}/upgrade-management-service/v1/calculated-features`;
export const fetchFeatureInterest = productLevelFilter => {
  return http.get(ENDPOINT, {
    query: {
      productLevel: productLevelFilter
    }
  }).catch(error => {
    if (error && error.status !== 0) {
      Raven.captureException(error);
    }

    throw error;
  });
};